import React, { useEffect, useState, useMemo } from "react";
import { useForm, Controller, useWatch } from "react-hook-form";
import CustomDatatableGrid from "../../components/CustomDatatableGrid";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import logo from "../../assets/img/logo-full.png";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";
import Select from "react-select";
import DropdownWithCustomValuesModal from "../../components/DropdownWithCustomValuesModal";

function Users() {
  const token = localStorage.getItem("token");
  const organizationId =
    localStorage.getItem("organizationId") === "null" ||
    localStorage.getItem("organizationId") === "0"
      ? 0
      : localStorage.getItem("organizationId");

  const savedCenterId =
    localStorage.getItem("centerId") === "0" ||
    localStorage.getItem("centerId") === "null"
      ? 0
      : localStorage.getItem("centerId");

  const [triggerRerender, setTriggerRerender] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [roleData, setRoleData] = useState([]);
  const [DepartmentData, setDepartmentData] = useState([]);
  const [userTypeId, setuserType] = useState("");
  const [departmentId, setDepartmentId] = useState("");
  const [provincesData, setProvincesData] = useState([]);
  const [citiesData, setCitiesData] = useState([]);
  const [selectedCenterId, setselectedCenterId] = useState(savedCenterId || 0);
  const [centersData, setCentersData] = useState([]);
  /* eslint-disable no-unused-vars */
  const [profilePicName, setProfilePicName] = useState("");
  const username = localStorage.getItem("username");
  const roleId = localStorage.getItem("roleId");
  const [isModalVisible, setModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [activityCategoryData, setActivityCategoryData] = useState([]);
  const [activityVenueData, setActivityVenueData] = useState([]);
  const [customDropdownName, setCustomDropdownName] = useState("");
  const [
    isCustomDropdownValuesModalVisible,
    setIsCustomDropdownValuesModalVisible,
  ] = useState(false);
  const getRoles = async () => {
    if (!token) return [];
    try {
      const response = await get(`Role/GetRoleByCenterId?id=${savedCenterId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setRoleData(response || []);
      return response || [];
    } catch (error) {
      console.error("Error fetching Roles:", error);
      return [];
    }
  };
  const getDepartments = async () => {
    if (!token) return [];
    try {
      const response = await get(
        `CommonSettings/GetCommonSettingDetailByModuleName?moduleName=${"Department"}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setDepartmentData(response?.commonSettingDetail || []);
      return response?.commonSettingDetail || [];
    } catch (error) {
      console.error("Error fetching Roles:", error);
      return [];
    }
  };
  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    trigger,
    reset,
    getValues,
  } = useForm({
    defaultValues: { id: 0, name: "" },
  });

  const [userData, setuserData] = useState([]);

  const getUserList = async (accountString, centerIdOverride) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }
    // Logic: Use override if NOT undefined (can be 0). If undefined, use state. 
    // If state is null/undefined, default to 0. 
    // Careful: 0 is falsy. Check for undefined explicitly.
    const actingCenterId = centerIdOverride !== undefined ? centerIdOverride : (selectedCenterId || 0);
    const queryCenterId = actingCenterId; 
    const queryAccountString = accountString || "";

    try {
      const response = await get(
        `UserAuthentication/GetUsersByCenterId?centerId=${queryCenterId}&organizationId=${organizationId}&accountString=${queryAccountString}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setuserData(response);
    } catch (error) {
      console.error("Error fetching Users:", error);
    }
  };

  useEffect(() => {
    getRoles();
    getDepartments();
    fetchProvincesData();
    
     // For Campus Officer (Role 3), prepopulate center and accountString
    if (roleId === "3") {
       const userAccountString = localStorage.getItem("accountString") || "";
       const userCenterId = localStorage.getItem("centerId");

       setValue("accountString", userAccountString);
       
       if (userCenterId) {
           const cId = parseInt(userCenterId, 10);
           setselectedCenterId(cId);
           
           // Fetch Center Details since we don't have name
           // Use the generic Dashboard/GetCenterByCityCode?code=... requires city code
           // But we don't have city code. 
           // Try fetching by Center ID using 'Center/GetCenterById' or similar if available?
           // Alternatively, since we are Role 3, we likely have access to our own center info?
           // Let's use `Center/GetCenterById?id=${cId}` or iterate through available if possible.
           // NOTE: The user requested to match ID in "get centers listing api". 
           // BUT the center listing API (GetCenterByCityCode) REQUIRES City Code.
           // We have account string LVLD1371-LVLD1700 -> Province-City.
           // parse accountString to get City Code -> Fetch Centers -> Find ID -> Set Label.
           
           if (userAccountString) {
               const parts = userAccountString.split('-');
               if (parts.length > 1) {
                   const cityCode = parts[1];
                   // We must define this as async to await fetch. 
                   // Since useEffect can't be async, we wrap in IIFE
                   (async () => {
                       const centers = await fetchCentersByCityCode(cityCode);
                       const found = centers.find(c => c.id === cId);
                       if (found) {
                           setValue("centerId", { value: cId, label: found.name });
                       } else {
                            setValue("centerId", { value: cId, label: `Center ${cId}` });
                       }
                   })();
               } else {
                   setValue("centerId", { value: cId, label: `Center ${cId}` });
               }
           } else {
               setValue("centerId", { value: cId, label: "Current Center" });
           }
           
       getUserList(userAccountString, cId); 
     } else {
        getUserList();
     }
   } else {
      getUserList();
   }
  }, [triggerRerender]);

  // ==================== FETCH FUNCTIONS FROM DASHBOARD ====================
  const fetchProvincesData = async () => {
    try {
      const response = await get(
        `Dashboard/GetSatateByOrganizationId?organizationId=${organizationId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setProvincesData(response || []);
      return response || [];
    } catch (error) {
      console.error("Error fetching provinces:", error);
      return [];
    }
  };

  const fetchCitiesByProvinceCode = async (stateCode) => {
    if (!stateCode) {
      setCitiesData([]);
      return [];
    }
    try {
      const code = typeof stateCode === "object" ? stateCode.code : stateCode;
      const response = await get(`Dashboard/GetCityByStateCode?code=${code}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCitiesData(response || []);
      return response || [];
    } catch (error) {
      console.error("Error fetching cities by province code:", error);
      setCitiesData([]);
      return [];
    }
  };

  const fetchCentersByCityCode = async (cityCode) => {
    if (!cityCode) {
      setCentersData([]);
      return [];
    }
    try {
      const response = await get(
        `Dashboard/GetCenterByCityCode?code=${cityCode}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCentersData(response || []);
      return response || [];
    } catch (error) {
      console.error("Error fetching centers by city code:", error);
      setCentersData([]);
      return [];
    }
  };

  /* eslint-disable react-hooks/exhaustive-deps */
  const columns = useMemo(
    () => [
      {
        accessorKey: "mrt-row-numbers",
        header: "Sr No.",
        enableColumnOrdering: false,
        enableEditing: false, 
        enableSorting: false,
        size: 60,
        Cell: ({ row }) => row.index + 1,
      },
      {
        accessorKey: "firstName",
        header: "First Name",
      },
      {
        accessorKey: "lastName",
        header: "Last Name",
      },
      {
        accessorKey: "email",
        header: "Email",
        size: 200,
      },
      {
        accessorKey: "userName",
        header: "Username",
        size: 200,
      },
      {
        accessorKey: "passwordHash",
        header: "Password",
        size: 200,
      },
      {
        accessorKey: "actions",
        header: "Action",
        size: 120,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <div className="d-flex gap-1">
            <button
              type="button"
              className="btn p-0"
              onClick={() => handleEditClick(row.original.userName)}
            >
              <i className="fas fa-pencil"></i>
            </button>
            <button
              type="button"
              className="btn p-0"
              onClick={() => handleDeleteClick(row.original.id)}
            >
              <i className="fas fa-trash"></i>
            </button>
            {username === "superadmin" ? (
              <button
                type="button"
                className="btn p-0"
                onClick={() => showUserModal(row.original.id)}
              >
                <i className="fas fa-lock"></i>
              </button>
            ) : (
              ""
            )}
          </div>
        ),
      },
    ],
    [username]
  );
  
  const exportToExcel = () => {
    const dataToExport = userData.map((row, index) => ({
      "Sr No": index + 1,
      "First Name": row.firstName,
      "Last Name": row.lastName,
      Email: row.email,
      Username: row.userName,
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Users");
    XLSX.writeFile(workbook, "Users.xlsx");
  };

  const loadImage = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = url;
      img.onload = () => resolve(img);
      img.onerror = (e) => reject(e);
    });
  };

  const exportToPDF = async () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const logoWidth = 30;
    const logoHeight = 8;
    // const logoX = (pageWidth - logoWidth) / 2;
    const logoY = 10;

    const roleId = localStorage.getItem("roleId");
    const orgLogoPath = localStorage.getItem("organizationLogoPath");
    const centerLogoPath = localStorage.getItem("centerLogoPath");
    const domain = (process.env.REACT_APP_LIVE_DOMAIN_URL || "").replace(/\/$/, "");
    
    const cleanPath = (path) => (path ? path.replace(/^\/+/, "") : "");
    const orgLogo = orgLogoPath ? `${domain}/ExternalImages/${cleanPath(orgLogoPath)}` : null;
    const centerLogo = centerLogoPath ? `${domain}/ExternalImages/${cleanPath(centerLogoPath)}` : null;

    let logoToUse = logo; // Default imported logo
    let sidebarLogoUrl = null;

    if (roleId == "2") sidebarLogoUrl = orgLogo;
    else if (roleId == "3") sidebarLogoUrl = centerLogo;

    if (sidebarLogoUrl) {
      try {
        logoToUse = await loadImage(sidebarLogoUrl);
      } catch (error) {
        console.warn(
          "Failed to load sidebar logo, falling back to default.",
          error
        );
      }
    }

    const title = "Users List";
    const titleFontSize = 12;
    doc.setFontSize(titleFontSize);
    doc.setFont("helvetica", "bold");
    const textWidth = doc.getTextWidth(title);
    const titleX = (pageWidth - textWidth) / 2;
    const titleY = logoY + logoHeight + 10;
    doc.text(title, titleX, titleY);

    const includedColumns = columns.filter((column) => column.accessorKey !== "actions" && column.accessorKey !== "passwordHash");

    const headers = includedColumns.map((col) => col.header);

    const bodyData = userData.map((row, index) => {
      return includedColumns.map((column) => {
          if (column.accessorKey === 'mrt-row-numbers') return index + 1;
          return row[column.accessorKey] || "";
      });
    });

    doc.autoTable({
      head: [headers],
      body: bodyData,
      theme: "striped",
      startY: titleY + 10,
      headStyles: {
        fillColor: [132, 23, 26],
        textColor: [255, 255, 255],
      },
    });

    doc.save("UsersList.pdf");
  };

  const handleEditClick = async (userName) => {
    try {
      const response = await get(
        `User/GetUserById?userName=${encodeURIComponent(userName)}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const selectedCategory = response.user;

      // Ensure roles and departments are available
      let currentRoles = roleData;
      if (!currentRoles || currentRoles.length === 0) {
          currentRoles = await getRoles();
      }

      let currentDepts = DepartmentData;
      if (!currentDepts || currentDepts.length === 0) {
          currentDepts = await getDepartments();
      }

      // Find role and department objects for React Select (Loose comparison)
      // eslint-disable-next-line eqeqeq
      let selectedRole = currentRoles.find(r => r.id == selectedCategory.roleId);
      // eslint-disable-next-line eqeqeq
      const selectedDept = currentDepts.find(d => d.id == selectedCategory.departmentId);

      // Fallback if role object not found but we have name
      if (!selectedRole && selectedCategory.role) {
          selectedRole = { id: selectedCategory.roleId, name: selectedCategory.role };
      }

      // Prep objects
      const userTypeObj = selectedRole ? { value: selectedRole.id, label: selectedRole.name } : null;
      const deptObj = selectedDept ? { value: selectedDept.id, label: selectedDept.value } : null;

      // Data Prep for Cascading Dropdowns
      let provinceObj = null;
      let cityObj = null;
      let centerObj = null;

      // Parse accountString
      if (selectedCategory.accountString) {
          const parts = selectedCategory.accountString.split('-');
          const provinceCode = parts[0];
          const cityCode = parts.length > 1 ? parts[1] : null;

          if (provinceCode) {
              // Note: provincesData is assumed loaded on mount. 
              // If not, we might need to await fetchProvincesData(), but it returns promise.
              
              // Find Province in existing data state
              provinceObj = provincesData.find(p => p.code === provinceCode);
              
              if (!provinceObj && provincesData.length === 0) {
                   const fetchedProvinces = await fetchProvincesData();
                   provinceObj = fetchedProvinces.find(p => p.code === provinceCode);
              }

              // Prep object for Select
              if (provinceObj) {
                  provinceObj = { 
                      value: provinceObj.code, 
                      label: provinceObj.name, 
                      code: provinceObj.code, 
                      extra: provinceObj.code 
                  };

                  // Fetch Cities
                  const fetchedCities = await fetchCitiesByProvinceCode(provinceCode);
                  
                  if (cityCode) {
                      const foundCity = fetchedCities.find(c => c.code === cityCode);
                      if (foundCity) {
                          cityObj = { 
                              value: foundCity.code, 
                              label: foundCity.name, 
                              code: foundCity.code, 
                              extra: foundCity.code 
                          };
                          
                          // Fetch Centers
                          const fetchedCenters = await fetchCentersByCityCode(cityCode);
                          
                          if (selectedCategory.centerId) {
                               const foundCenter = fetchedCenters.find(c => c.id === selectedCategory.centerId);
                               if (foundCenter) {
                                   centerObj = { value: foundCenter.id, label: foundCenter.name };
                               } else {
                                   // Fallback if center not found in list
                                   centerObj = { value: selectedCategory.centerId, label: selectedCategory.centerName || "Center" };
                               }
                          }
                      }
                  }
              }
          }
      } 
      
      // Fallback: If no account string but centerId exists (Org Level Center?)
      if (!centerObj && selectedCategory.centerId) {
           centerObj = { value: selectedCategory.centerId, label: selectedCategory.centerName || "Center" };
      }

      reset({
        id: selectedCategory.id,
        userName: selectedCategory.userName,
        firstName: selectedCategory.firstName,
        lastName: selectedCategory.lastName,
        email: selectedCategory.email,
        mobileNumber: selectedCategory.mobileNumber,
        profilePicName: selectedCategory.profilePicName,
        accountString: selectedCategory.accountString,
        userTypeId: userTypeObj,
        departmentId: deptObj,
        provinceId: provinceObj,
        cityId: cityObj,
        centerId: centerObj
      });
      
      setProfilePicName(selectedCategory.profilePicName);
      
      // Profile Pic Preview Logic
      if (selectedCategory.profilePicPath) {
           const imageUrl = `${process.env.REACT_APP_LIVE_DOMAIN_URL}/ExternalImages/${selectedCategory.profilePicPath}`;
           setPreviewUrl(imageUrl);
      } else {
           setPreviewUrl(null);
      }

      if (selectedCategory.centerId) {
          setselectedCenterId(selectedCategory.centerId);
      }
    } catch (error) {
      console.error("Error editing user:", error);
    }
  };

  const handleDeleteClick = async (rowId) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this user?"
    );
    if (confirmDelete) {
      try {
        const response = await get(`User/DeleteUserById?id=${rowId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        getUserList(getValues("accountString"));
      } catch (error) {
        console.error("Error deleting user:", error);
      }
    }
  };

  const saveData = async (data) => {
    // Extract values from React Select objects
    const userTypeIdValue = data.userTypeId?.value || data.userTypeId;
    const departmentIdValue = data.departmentId?.value || data.departmentId;

    let payload = {
      ...data,
      userTypeId: userTypeIdValue,
      departmentId: departmentIdValue,
      centerId: data?.centerId?.value || null,
      accountString: data.accountString || "", // Default empty if not managed
      organizationId: organizationId,
      profilePicName: profilePicName,
      base64String: getValues("base64String"),
      mobileNumber: data.mobileNumber,
    };
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await post(`User/AddUpdateUser`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        setTriggerRerender((prev) => !prev);
        reset({
          id: 0,
          userName: "",
          firstName: "",
          lastName: "",
          email: "",
          userTypeId: null,
          departmentId: null,
          organizationId: organizationId,
          profilePicName: profilePicName,
          base64String: "",
          mobileNumber: "",
          centerId: null,
          provinceId: null,
          cityId: null,
        });
        setuserType(0); // Reset local state if still used elsewhere, though now mostly form managed
        setDepartmentId("");
        setProfilePicName("");
        setPreviewUrl(null);
        setselectedCenterId(savedCenterId || 0);
        // Refresh grid with default/reset values
        getUserList("", savedCenterId || 0);
      }  
      setDepartmentId("");
      setProfilePicName("");
      setPreviewUrl(null);
      setselectedCenterId(savedCenterId || 0);
      // Refresh grid with default/reset values
      getUserList("", savedCenterId || 0);
      
    } catch (error) {
      console.error("Error saving category:", error);
    }
  };

  const handleUserTypeDropdownChange = (event) => {
    const selectedUserTypeId = Number(event.target.value);
    setuserType(selectedUserTypeId);
  };

  const handleDepartmentDropdownChange = (event) => {
    const selectedDepartmentId = Number(event.target.key);
    setDepartmentId(selectedDepartmentId);
  };

  const selectedProvince = useWatch({ control, name: "provinceId" });
  const selectedCity = useWatch({ control, name: "cityId" });

  useEffect(() => {
      if (roleId === "3") return;
      
      // Construct Account String
      const pCode = selectedProvince?.code || "";
      const accountStr = pCode;
      
      setValue("accountString", accountStr);

      if (selectedProvince?.extra) { 
        fetchCitiesByProvinceCode(selectedProvince); 
      } else if (selectedProvince?.code) {
        fetchCitiesByProvinceCode(selectedProvince);
      } else {
          setCitiesData([]);
      }
      
      // Clearing logic moved to onChange
      
      getUserList(accountStr, 0); 
  }, [selectedProvince?.value]); 

  useEffect(() => {
      if (roleId === "3") return;

      // Construct Account String
      const pCode = selectedProvince?.code || "";
      const cCode = selectedCity?.code || "";
      const accountStr = [pCode, cCode].filter(Boolean).join("-");
      
      setValue("accountString", accountStr);

      if (selectedCity?.code || selectedCity?.extra) {
         fetchCentersByCityCode(selectedCity.code || selectedCity.extra);
      } else {
         setCentersData([]);
      }
      
      // Clearing logic moved to onChange
      
      getUserList(accountStr, 0);
  }, [selectedCity?.value]);
  
  /* eslint-disable react-hooks/exhaustive-deps */
  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setProfilePicName(file.name); // Capture the file name

      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1]; // Get the base64 string
        setValue("base64String", base64String, { shouldValidate: true });
        setPreviewUrl(reader.result);
        trigger("profilePicName");
      };
      reader.readAsDataURL(file);
    } else {
      setPreviewUrl(null);
    }
  };
  const showUserModal = (user) => {
    setSelectedUser(user);
    setModalVisible(true);
  };

  const hideUserModal = () => {
    setModalVisible(false);
    setSelectedUser(null);
  };

  const submitUserDetails = (data) => {
    // Call your API to save user details
    console.log(data);
    hideUserModal();
  };
  const resetPassword = async () => {
    const newPassword = getValues("password");
    const confirmPassword = getValues("confirmPassword");
    const selectedUser = getValues("selectedUser");
    const requestData = {
      userId: selectedUser, // Assuming selectedUser has an id
      newPassword,
      confirmPassword,
      token: token, // If applicable
    };

    try {
      const response = await post(
        `UserAuthentication/ChangePassword`,
        requestData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        setTriggerRerender((prev) => !prev);
        hideUserModal();
      } else {
        toast.error(response.message || "Error!");
      }
      if (!response.ok) {
        throw new Error("Network response was not ok " + response.statusText);
      }

      const result = await response.json();
      console.log("Response Data:", result);

      // Handle success (e.g., show a success message, close the modal)
    } catch (error) {
      console.error("Error during form submission:", error);
      // Handle error (e.g., show an error message)
    }
  };
  const handleCustomDropdownSetting = (dropdownName) => {
    setCustomDropdownName(dropdownName);
    setIsCustomDropdownValuesModalVisible(true);
  };
  const fetchCommonSettings = async (moduleName, setData) => {
    try {
      const response = await get(
        `CommonSettings/GetCommonSettingDetailByModuleName?moduleName=${moduleName}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setData(response?.commonSettingDetail);
    } catch (error) {
      console.error(`Error fetching ${moduleName}:`, error);
    }
  };


  return (
    <>
      {isModalVisible && (
        <div
          className="modal fade show"
          tabIndex="-1"
          style={{ display: "block" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <form>
                <div className="modal-header">
                  <h5 className="mb-0">Reset Password</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={hideUserModal}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label form-label-new">
                      Username
                      <span className="text-danger fs-9">*</span>
                    </label>
                    <input
                      {...register("selectedUser", {
                        required: "This field is required.",
                      })}
                      type="text"
                      className="form-control"
                      value={selectedUser}
                    />
                    {errors.username && (
                      <small className="text-danger">
                        {errors.username.message}
                      </small>
                    )}
                  </div>
                  {/* <div className="mb-3">
                    <label className="form-label form-label-new">
                      Current Password
                      <span className="text-danger fs-9">*</span>
                    </label>
                    <input
                      {...register("currentPassword", {
                        required: "Current password is required.",
                      })}
                      type="password"
                      className="form-control"
                    />
                    {errors.currentPassword && (
                      <small className="text-danger">
                        {errors.currentPassword.message}
                      </small>
                    )}
                  </div> */}

                  <div className="mb-3">
                    <label className="form-label form-label-new">
                      Password
                      <span className="text-danger fs-9">*</span>
                    </label>
                    <input
                      {...register("password", {
                        required: "This field is required.",
                      })}
                      type="password"
                      className="form-control"
                    />
                    {errors.password && (
                      <small className="text-danger">
                        {errors.password.message}
                      </small>
                    )}
                  </div>

                  <div className="mb-3">
                    <label className="form-label form-label-new">
                      Confirm Password
                      <span className="text-danger fs-9">*</span>
                    </label>
                    <input
                      {...register("confirmPassword", {
                        required: "This field is required.",
                        validate: (value) =>
                          value === watch("password") ||
                          "Passwords do not match.",
                      })}
                      type="password"
                      className="form-control"
                    />
                    {errors.confirmPassword && (
                      <small className="text-danger">
                        {errors.confirmPassword.message}
                      </small>
                    )}
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    onClick={resetPassword}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={hideUserModal}
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Users</h2>
      </div>

      <form
        className="row g-3 new-form-style"
        onSubmit={handleSubmit(saveData)}
      >
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div className="row g-3">
                  <>
                    {/* Hide Province and City for Role 3 */}
                    {roleId !== "3" && (
                    <>
                    <div className="col-md-4">
                      <label className="form-label form-label-new">
                        State / Province
                      </label>
                      <Controller
                        name="provinceId"
                        control={control}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={provincesData.map((p) => ({
                                value: p.code,
                                label: p.name,
                                code: p.code,
                                extra: p.code 
                            }))}
                            onChange={(val) => {
                                field.onChange(val);
                                // Logic to clear children on user interaction
                                setValue("cityId", null);
                                setValue("centerId", null);
                                setselectedCenterId(0);
                                setCentersData([]); // Clear centers data because city is cleared
                            }}
                            className="react-select-style"
                            classNamePrefix="react-select-style-pref"
                            isClearable
                          />
                        )}
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label form-label-new">
                        City
                      </label>
                      <Controller
                        name="cityId"
                        control={control}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={citiesData.map((c) => ({
                                value: c.code,
                                label: c.name,
                                code: c.code,
                                extra: c.code
                            }))}
                            onChange={(val) => {
                                field.onChange(val);
                                // Logic to clear children on user interaction
                                setValue("centerId", null);
                                setselectedCenterId(0);
                            }}
                            className="react-select-style"
                            classNamePrefix="react-select-style-pref"
                            isClearable
                          />
                        )}
                      />
                    </div>
                    </>
                    )}
                    <div className="col-md-4">
                      <label className="form-label form-label-new">
                        Center
                      </label>
                      <Controller
                        name={`centerId`}
                        control={control}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={centersData.map((center) => ({
                              value: center.id,
                              label: center.name,
                            }))}
                            isDisabled={roleId === "3"} // Disable for Campus Officer
                            onChange={(selectedOption, actionMeta) => {
                              const newCenterId = selectedOption ? selectedOption.value : 0; // Default to 0 or null
                              if (actionMeta.action === "clear") {
                                setValue(`centerId`, null);
                                setselectedCenterId(null);
                              } else {
                                setValue(
                                  `centerId`,
                                  selectedOption || { value: 0, label: "" }
                                );
                                setselectedCenterId(newCenterId);
                              }
                              // Manually trigger user list refresh
                              const currentAccountString = getValues("accountString");
                              getUserList(currentAccountString, newCenterId);
                              
                              trigger(`centerId`);
                            }}
                            className="react-select-style"
                            classNamePrefix="react-select-style-pref"
                            isClearable={roleId !== "3"} // Allow clearing only if not Campus Officer
                          />
                        )}
                      />
                    </div>
                  </>
                <div className="col-md-12 mt-3 d-none">
                  <label className="form-label form-label-new">
                    Account String
                    <span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register("accountString", {
                      // required: "This field is required.", // Removed
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                    disabled={true}
                  />
                  {errors.accountString && (
                    <small className="text-danger">
                      {errors.accountString.message}
                    </small>
                  )}
                </div>
                <div className="col-12">
                  <div className="row g-3 justify-content-center">
                    <div className="col-md-5">
                      <div className="image-uploader-wrapper d-flex flex-column align-items-center">
                        <div className="image-preview d-flex justify-content-center align-items-center mb-3">
                          {previewUrl ? (
                            <img src={previewUrl} alt="Preview" />
                          ) : (
                            <div>
                              <span className="fas fa-image fs-3 text-light"></span>
                            </div>
                          )}
                        </div>
                        <label className="form-label">Profile Picture</label>
                        <input
                          {...register("profilePicName")}
                          type="file"
                          className="form-control "
                          accept="image/*"
                          onChange={handleFileChange}
                        />
                        {/* <div>
                          {profilePicName ? (
                            <span>{profilePicName}</span> // Display the profile picture name
                          ) : (
                            <span>No file chosen</span>
                          )}
                        </div> */}
                      </div>
                      {errors.centerImage && (
                        <small className="text-danger">
                          {errors.centerImage.message}
                        </small>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <label className="form-label form-label-new">
                    User Type / Role<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="userTypeId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={roleData.map((category) => ({
                          value: category.id,
                          label: category.name,
                        }))}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        placeholder="Select"
                      />
                    )}
                  />
                  {errors.userTypeId && (
                    <small className="text-danger">
                      {errors.userTypeId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label form-label-new">
                    Department<span className="text-danger fs-9">*</span>
                  </label>
                  <div className="d-flex gap-2">
                    <div className="w-100">
                      <Controller
                        name="departmentId"
                        control={control}
                        rules={{ required: "This field is required." }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={DepartmentData.map((center) => ({
                              value: center.id,
                              label: center.value,
                            }))}
                            className="react-select-style"
                            classNamePrefix="react-select-style-pref"
                            placeholder="Select"
                          />
                        )}
                      />
                      {errors.departmentId && (
                        <small className="text-danger">
                          {errors.departmentId.message}
                        </small>
                      )}
                    </div>
                    <div>
                      <button
                        type="button"
                        className="btn btn-outline-primary px-2 lh-1"
                        onClick={() =>
                          handleCustomDropdownSetting("Department")
                        }
                      >
                        <i className="fas fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>
                
                <div className="col-md-6">
                  <label className="form-label form-label-new">
                    First Name<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register(`firstName`, {
                      required: "This field is required.",
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                  />
                  {errors.firstName && (
                    <small className="text-danger">
                      {errors.firstName.message}
                    </small>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label form-label-new">
                    Last Name<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register(`lastName`, {
                      required: "This field is required.",
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                  />
                  {errors.lastName && (
                    <small className="text-danger">
                      {errors.lastName.message}
                    </small>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label form-label-new">
                    Email<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register(`email`, {
                      required: "This field is required.",
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                  />
                  {errors.email && (
                    <small className="text-danger">
                      {errors.email.message}
                    </small>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label form-label-new">
                    Phone Number<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register(`mobileNumber`, {
                      required: "This field is required.",
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                  />
                  {errors.mobileNumber && (
                    <small className="text-danger">
                      {errors.mobileNumber.message}
                    </small>
                  )}
                </div>
                <div className="col-12">
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Save" : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div className="table-container fixed-last-column-table">
                <CustomDatatableGrid
                  columns={columns}
                  data={userData}
                  onExportExcel={exportToExcel}
                  onExportPDF={exportToPDF}
                  initialState={{
                    columnPinning: { right: ["actions"] },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </form>
      {isCustomDropdownValuesModalVisible && (
        <DropdownWithCustomValuesModal
          dropdownName={customDropdownName}
          onClose={() => {
            setIsCustomDropdownValuesModalVisible(false);
            if (customDropdownName === "activityCategoryId") {
              fetchCommonSettings(
                "activityCategoryId",
                setActivityCategoryData
              );
            } else if (customDropdownName === "activityVenueId") {
              fetchCommonSettings("activityVenueId", setActivityVenueData);
            }
          }}
        />
      )}
    </>
  );
}

export default Users;
